import React from "react";
import "../../scss/dashboard/deletemodal.css";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
function DeleteModal({ modal, handleClose }) {
  return (
    <Modal isOpen={modal} style={{ paddingTop: "7vw" }}>
      <ModalBody
        style={{ margin: "0px auto", width: "500px", height: "250px" }}
      >
        <div
          style={{
            display: "grid",
            height: "100%",
            gridTemplateRows: "18% 55% 27%",
          }}
          className="ModalGrid"
        >
          <div className="ModalGridHeader">
            <span>Eliminar Plantilla</span>
            <div onClick={handleClose} style={{ cursor: "pointer" }}>
              <span>X</span>
            </div>
          </div>
          <div>
            <p>
              ¿Estas seguro de eliminar esta Plantilla? Se borrara la
              información permanentemente del sistema?
            </p>
          </div>
          <div className="ModalGridButtons">
            <div onClick={handleClose} className="ModalGridButtons__one">
              <span>Cancelar</span>
            </div>
            <div onClick={handleClose} className="ModalGridButtons__two">
              <span>Eliminar</span>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default DeleteModal;
